<script lang="ts">
  import type { Attachment } from '../../shared/types';
  import { formatBytes } from '../ui';

  let { attachments }: { attachments: Attachment[] } = $props();
</script>

<div class="attachments">
  {#each attachments as attachment (attachment.id)}
    {#if attachment.kind === 'image'}
      <a href={attachment.url} target="_blank" rel="noreferrer" class="att-image">
        <img src={attachment.url} alt={attachment.name ?? 'image'} loading="lazy" />
      </a>
    {:else if attachment.kind === 'video'}
      <video class="att-video" src={attachment.url} controls preload="metadata"></video>
    {:else if attachment.kind === 'voice' || attachment.kind === 'audio'}
      <audio class="att-audio" src={attachment.url} controls preload="metadata"></audio>
    {:else}
      <a class="att-file" href={attachment.url} target="_blank" rel="noreferrer">
        <span class="att-file-name">{attachment.name ?? 'File'}</span>
        <span class="att-file-meta">{formatBytes(attachment.size)}</span>
      </a>
    {/if}
  {/each}
</div>
